/* ============
 * businessHourExceptions Transformer
 * ============
 */

import Transformer from './transformer';

export default class businessHourExceptionsTransformer extends Transformer {

  static fetch(businessHourException) {
    return {
      id: businessHourException.id,
      start: businessHourException.start,
      end: businessHourException.end,
      message: businessHourException.message,
      confirmed: businessHourException.confirmed,
    };
  }

  static send(businessHourException) {
    return {
      id: businessHourException.id,
      start: businessHourException.start,
      end: businessHourException.end,
      message: businessHourException.message,
      confirmed: businessHourException.confirmed,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/businessHourException.js